import axios from 'services/axios'

export interface StrAdminHost {
  id: string
  hostId: string
  isVisible: boolean
  entityDetails: {
    name: string
    tin: string
    location: string
  }
  totals: {
    hostName: string
    totalListings: number
    numberOfReviews: number
  }
}

interface HostsResponse {
  hosts: StrAdminHost[]
  total: number
}

export interface UiConfigOverviewSection {
  hostsCount?: boolean
  documentedRevenue?: boolean
  reportedRevenue?: boolean
  taxGap?: boolean
  listingsCount?: boolean
}

export interface UiConfigEntityPage {
  revenueSummary?: boolean
  chart?: boolean
  sectionTitle?: boolean
  statsCard?: boolean
  listingDocumentedRevenue?: boolean
}

export interface UiConfig {
  id: string
  uiConfigEnabled: boolean
  overviewBar: {
    hosts: UiConfigOverviewSection
    listings: UiConfigOverviewSection
  }
  entityPage?: UiConfigEntityPage
}

export const fetchAdminHosts = async (
  from: number = 0,
  size: number = 50,
  searchValue?: string,
  sorting?: { id: string; desc: boolean },
): Promise<HostsResponse> => {
  const params: Record<string, any> = { from, size }
  if (searchValue) params.searchValue = searchValue
  if (sorting) params.sorting = JSON.stringify(sorting)
  const { data } = await axios.get('str-admin/hosts', { params })
  return data
}

export const toggleHostVisibility = async (
  hostId: string,
  isVisible: boolean,
): Promise<StrAdminHost> => {
  const { data } = await axios.request({
    url: 'str-admin/hosts/' + hostId + '/visibility',
    method: 'PATCH',
    data: { isVisible },
  })
  return data
}

export const bulkToggleVisibility = async (
  hostIds: string[],
  isVisible: boolean,
): Promise<{ modifiedCount: number }> => {
  const { data } = await axios.request({
    url: 'str-admin/hosts/bulk-visibility',
    method: 'PATCH',
    data: { hostIds, isVisible },
  })
  return data
}

export const fetchUiConfig = async (): Promise<UiConfig> => {
  const { data } = await axios.get('str-admin/ui-config')
  return data
}

export const updateUiConfig = async (patch: Partial<UiConfig>): Promise<UiConfig> => {
  const { data } = await axios.request({
    url: 'str-admin/ui-config',
    method: 'PATCH',
    data: patch,
  })
  return data
}
